import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { getNominative } from '../../../common/utils'
import {
  SectionHeader as AnySectionHeader,
  FamilyInviteWizard
} from '../../../components/generic'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SectionHeader = AnySectionHeader as any

const Container = styled.div`
  margin: 55px auto 50px;
  max-width: 1080px;
  padding: 0 30px;
`

const Subtitle = styled.p`
  margin-bottom: 20px;
`

export function FamilyInviteScreen() {
  const preferredPeopleNominative = useSelector(
    (state: { global: { home: { preferredPeopleNominative: string } } }) =>
      state.global.home.preferredPeopleNominative
  )

  if (!preferredPeopleNominative) {
    return null
  }

  const preferredTerm = getNominative(
    preferredPeopleNominative,
    'Resident'
  ).toLowerCase()

  return (
    <Container>
      <SectionHeader title={'Invite Family Members'} />
      <Subtitle>
        Once you know a {preferredTerm} is happy to share their information and
        a family member is interested in the App, you can start inviting them
        straight away.
      </Subtitle>
      <FamilyInviteWizard />
    </Container>
  )
}

export default FamilyInviteScreen
